import { Button } from "../../components/ui/button";
import { Label } from "../../components/ui/label";
import {
  Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle,
} from "../../components/ui/dialog";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "../../components/ui/select";
import { Switch } from "../../components/ui/switch";
import { Separator } from "../../components/ui/separator";

const months = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

const currentYear = new Date().getFullYear();
const years = Array.from({ length: 3 }, (_, i) => currentYear - 1 + i);

const BulkGenerateDialog = ({
  open,
  onOpenChange,
  selectedMonth,
  setSelectedMonth,
  selectedYear,
  setSelectedYear,
  enablePF,
  setEnablePF,
  enableESI,
  setEnableESI,
  enablePT,
  setEnablePT,
  onGenerate,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="font-heading">Generate Bulk Payroll</DialogTitle>
          <DialogDescription>
            Generate payroll for all active employees with salary information.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 mt-4">
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>Month</Label>
              <Select value={selectedMonth} onValueChange={setSelectedMonth}>
                <SelectTrigger className="input-field" data-testid="bulk-month-select">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  {months.map((month) => (
                    <SelectItem key={month} value={month}>{month}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <div className="space-y-2">
              <Label>Year</Label>
              <Select value={selectedYear} onValueChange={setSelectedYear}>
                <SelectTrigger className="input-field" data-testid="bulk-year-select">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  {years.map((year) => (
                    <SelectItem key={year} value={year.toString()}>{year}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          </div>

          <div className="border rounded-lg p-4 space-y-3">
            <h4 className="font-medium text-slate-800 text-sm">Deduction Options</h4>
            <div className="flex items-center justify-between py-1">
              <div>
                <p className="text-sm font-medium text-slate-700">Provident Fund (PF)</p>
                <p className="text-xs text-slate-400">12% employee + 12% employer</p>
              </div>
              <Switch checked={enablePF} onCheckedChange={setEnablePF} data-testid="bulk-pf-switch" />
            </div>
            <Separator />
            <div className="flex items-center justify-between py-1">
              <div>
                <p className="text-sm font-medium text-slate-700">ESI</p>
                <p className="text-xs text-slate-400">0.75% employee + 3.25% employer</p>
              </div>
              <Switch checked={enableESI} onCheckedChange={setEnableESI} data-testid="bulk-esi-switch" />
            </div>
            <Separator />
            <div className="flex items-center justify-between py-1">
              <div>
                <p className="text-sm font-medium text-slate-700">Professional Tax</p>
                <p className="text-xs text-slate-400">State-based (max ₹200/month)</p>
              </div>
              <Switch checked={enablePT} onCheckedChange={setEnablePT} data-testid="bulk-pt-switch" />
            </div>
          </div>

          <Button className="w-full btn-primary" onClick={onGenerate} data-testid="bulk-generate-btn">
            Generate Payroll
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default BulkGenerateDialog;
